import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import ModuleCustomizationList from './ModuleCustomizationList';
import ModuleCustomizationListService from '../services/ModuleCustomizationListService';

class ModuleCustomizationListContainer extends Component {
  componentDidMount() {
    ModuleCustomizationListService.init();
  }

  render() {
    return (
      <ModuleCustomizationList
        customizations={toJS(ModuleCustomizationListService.customizations)}
        fetching={ModuleCustomizationListService.fetch.fetching}
        pagination={toJS(ModuleCustomizationListService.pagination)}
        onChange={ModuleCustomizationListService.handleChange}
        onDelete={ModuleCustomizationListService.handleRemove}
      />
    );
  }
}

export default observer(ModuleCustomizationListContainer);
